import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconBtn from "./IconBtn/IconBtn";

export default function ExportExcel(props) {
  const handleExport = () => {
    if (!props.dataToExport || props.dataToExport.length === 0) {
      return;
    }

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Process each sheet
    props.dataToExport.forEach((sheet) => {
      // Prepare data with headers
      const worksheetData = [];
      
      // Add header row
      if (sheet.sheetHeader && sheet.sheetHeader.length > 0) {
        worksheetData.push(sheet.sheetHeader);
      }

      // Add data rows
      if (sheet.sheetData && Array.isArray(sheet.sheetData)) {
        sheet.sheetData.forEach((row) => {
          // Map row data according to headers
          const rowData = sheet.sheetHeader.map((header) => {
            return row[header] !== undefined ? row[header] : "";
          });
          worksheetData.push(rowData);
        });
      }

      // Create worksheet from data
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, sheet.sheetName || "Sheet1");
    });

    // Generate Excel file buffer
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    
    // Create blob and save
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `${props.fileName || "export"}.xlsx`);

    // Call callback if provided
    if (props.callBack) {
      props.callBack();
    }
  };

  return (
    <IconBtn
      label="Télécharger"
      icon="download"
      handleClick={handleExport}
    />
  );
}
